module.exports = __webpack_public_path__ + "static/media/bg-image.b0ed9ac9.jpeg";